import React from 'react';
import { FacebookIcon, InstagramIcon, LinkedinIcon } from 'lucide-react';
import { Logo } from './Logo';
import { practice } from '../data/site';
import { footerLinks, legalLinks } from '../data/content';
import { scrollToSection } from '../utils/scrollToSection';
export function Footer() {
  return <footer className="border-t border-white/[0.06] bg-ink pb-28 pt-20 text-white lg:pb-14 lg:pt-24" data-id="element-251" data-mp="36oxw8w6378vq">
      <div className="mx-auto max-w-shell px-5 sm:px-8 lg:px-12" data-id="element-252" data-mp="3uesa9h2573hk">
        <div className="grid gap-12 border-b border-white/[0.08] pb-14 lg:grid-cols-12 lg:gap-10" data-id="element-253" data-mp="38qvoyiyxrr6">
          <div className="lg:col-span-5" data-id="element-254" data-mp="3lecb2jsfmiii">
            <Logo data-id="element-255" data-mp="3ldaobi2207ky" />
            <address className="mt-7 not-italic text-[14.5px] leading-[1.9] text-white/55" data-id="element-256" data-mp="3ldu34pweqfur">
              Lima Dental Group
              <br data-id="element-257" data-mp="3qf9qiom24ygb" />
              {practice.doctor}
              <br data-id="element-258" data-mp="29y5fdwbbxcsw" />
              {practice.address.street}
              <br data-id="element-259" data-mp="2eya0jzn6mvpg" />
              {practice.address.city}, {practice.address.region} {practice.address.postalCode}
              <br data-id="element-260" data-mp="3l90l3octskvk" />
              <a href={practice.phoneHref} className="hover:text-white" data-id="element-261" data-mp="3lalfndz543tf">
                {practice.phone}
              </a>
              {' · '}
              <a href={`mailto:${practice.email}`} className="hover:text-white" data-id="element-262" data-mp="3gctq2qlywtse">
                {practice.email}
              </a>
              <br data-id="element-263" data-mp="3q83rbc4jkx54" />
              <a href={practice.bookingUrl} target="_blank" rel="noreferrer" className="hover:text-white" data-id="element-264" data-mp="3q7lmhr3tdall">
                Book online: lima.dental
              </a>
            </address>

            <ul className="mt-7 flex gap-3" data-id="element-265" data-mp="hsk4ovydmcz1">
              {[{
              Icon: FacebookIcon,
              label: 'Facebook'
            }, {
              Icon: InstagramIcon,
              label: 'Instagram'
            }, {
              Icon: LinkedinIcon,
              label: 'LinkedIn'
            }].map(({
              Icon,
              label
            }) => <li key={label} data-id="element-266" data-mp="mrwplb5ot9yz">
                  <a href="#home" onClick={event => scrollToSection(event, '#home')} aria-label={`Lima Dental Group on ${label}`} className="flex h-11 w-11 items-center justify-center rounded-full border border-white/10 text-white/60 transition-colors hover:border-white/40 hover:text-white" data-id="element-267" data-mp="mspppta55185">
                    <Icon aria-hidden="true" className="h-4 w-4" strokeWidth={1.5} data-id="element-268" data-mp="18k943f0e10b0" />
                  </a>
                </li>)}
            </ul>
          </div>

          <nav aria-label="Page sections" className="lg:col-span-4" data-id="element-269" data-mp="1hkp4ugpqxtc6">
            <h2 className="eyebrow text-white/35" data-id="element-270" data-mp="1hiumna5v0fbs">Sections</h2>
            <ul className="mt-6 grid gap-3.5 sm:grid-cols-2" data-id="element-271" data-mp="1mktnode4n05k">
              {footerLinks.map(link => <li key={link.label} data-id="element-272" data-mp="1rhk3r0pxlvqz">
                  <a href={link.href} onClick={event => scrollToSection(event, link.href)} className="text-[14.5px] text-white/65 underline-offset-4 transition-colors hover:text-white hover:underline" data-id="element-273" data-mp="1rgirwu13d587">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </nav>

          <div className="lg:col-span-3" data-id="element-274" data-mp="25mkhizvt6khz">
            <h2 className="eyebrow text-white/35" data-id="element-275" data-mp="21nv5bamib8zx">Office hours</h2>
            <ul className="mt-6 space-y-2 text-[14.5px] leading-relaxed text-white/65" data-id="element-276" data-mp="1wnyzr6y5v9i9">
              {practice.hours.map(h => <li key={h.day} data-id="element-277" data-mp="2tcyacsm7wndm">
                  <span className="text-white/45" data-id="element-278" data-mp="2tbvjgkowakxp">{h.day}:</span> {h.value}
                </li>)}
            </ul>
            <p className="mt-5 text-[14px] leading-relaxed text-white/45" data-id="element-279" data-mp="2kdb9c7xehjl3">
              Walk-ins welcome · Care in English and Spanish
            </p>
          </div>
        </div>

        <div className="flex flex-col gap-5 pt-8 text-[13px] text-white/35 lg:flex-row lg:items-center lg:justify-between" data-id="element-280" data-mp="2fgkrbf21cdx1">
          <p data-id="element-281" data-mp="13zb88tmtjnw9">© {new Date().getFullYear()} Lima Dental Group · Miami Lakes, Florida.</p>
          <ul className="flex flex-wrap gap-x-6 gap-y-2" data-id="element-282" data-mp="2rvr9plmrh0ii">
            {legalLinks.map(link => <li key={link} data-id="element-283" data-mp="2wmfzmwislpfj">
                <a href="#home" onClick={event => scrollToSection(event, '#home')} className="underline-offset-4 hover:text-white hover:underline" data-id="element-284" data-mp="2wmptiv6ykgqi">
                  {link}
                </a>
              </li>)}
          </ul>
        </div>
      </div>
    </footer>;
}